import * as React from 'react';
import { DocLayout } from 'src/layouts/DocLayout';
import { Layout } from 'antd';
import { ResaleApiDoc } from 'src/containers/ResaleApiDoc';

export class ResaleDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
            <ResaleApiDoc/>
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ResaleDocPage/index.tsx